import showPwd from "../images/showPwd.png";
import hidePwd from "../images/hidePwd.png";
import bondLogo from '../logos/logo_bondai_theme.png';
import search from "../images/Search.png";
import avtar from "../images/avatar.png";
import invite from "../images/sendInviteBtn.svg";
import infoIcon from "../images/InfoCircle.png";
import defaultEnterpriseLogo from "../images/Enterprise logo.svg";

const fetchAllImages = {
    showPwd,
    hidePwd,
    bondLogo,
    search,
    avtar,
    invite,
    infoIcon,
    defaultEnterpriseLogo
}

export default fetchAllImages;